<template>
    <div class="event-actions">

    <!-- <div
      class="event-destination"
      v-if="hasUser && !isClosed"
      :title="'Проложить маршрут'"
      @click="setDestination()"
    >
      <p>Проложить маршрут</p>
      <img src="@/assets/images/icons/icon_destination.svg" />
    </div> -->
    <div
      class="event-add__photo"
      v-if="(event.users_can_add && hasUser) || isAuthor"
      :title="'Добавить фото в трансляцию'"
    >
      <input
          class="event-add__input"
          type="file"
          multiple
          @change="loadPhoto"
          name="translation-photo"
          max-size="5000"
          accept="image/*"
        />
      <p>Добавить фото в трансляцию</p>
      <img src="@/assets/images/icons/events/icon_add-photo.svg" />
    </div>
    <router-link
      :to="{ name: 'chat', params: { hash: event.chat.id + '&' + event.chat.hash } }"
      class="event-chat"
      v-if="hasUser && event && event.chat"
      :title="'Перейти в чат'"
    >
      <img src="@/assets/images/icons/events/icon_chat.svg" width="34px" />
      <!-- <span>{{ event.chat }}</span> -->
    </router-link>
    <div
      class="event-edit"
      @click="more = !more"
    >
      <font-awesome-icon icon="ellipsis-h" />
      <div class="dropdown" v-if="more">
        <div class="dropdown-item" v-if="!isAuthor" @click="$emit('setComplain', {event_id: event.id, type: 'event'})">
          <font-awesome-icon icon="exclamation-triangle" />
          <p>Пожаловаться</p>
        </div>
        <div class="dropdown-item" v-if="isAuthor" @click="editEvent()">
          <font-awesome-icon icon="pencil-alt" />
          <p>Редактировать</p>
        </div>
        <div class="dropdown-item" v-if="isAuthor" @click="$emit('deleteEvent')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
            <path
              d="M17 22H7a2 2 0 01-2-2V7H3V5h4V4a2 2 0 012-2h6a2 2 0 012 2v1h4v2h-2v13a2 2 0 01-2 2zM7 7v13h10V7H7zm2-3v1h6V4H9zm6 14h-2V9h2v9zm-4 0H9V9h2v9z"
            />
          </svg>
          <p>Удалить</p>
        </div>
      </div>
    </div>
    <div
      class="event-jointer"
      v-if="!hasUser && !isClosed && event.max_users > event.users.length"
      @click="$emit('join')"
      :class="{ joined: hasUser }"
    >
      <img src="@/assets/images/icons/icon_check.svg" width="24px" v-if="hasUser" />
      <img src="@/assets/images/icons/icon_plus.svg" width="24px" v-else />
    </div>
    </div>
</template>
<script>
export default {
    name: 'EventPanel',
    data: () => {
        return {
            more: false
        }
    },
    props: {
        event: {
            type: Object,
            require: true
        },
        isAuthor: {
            type: Boolean,
            require: true
        },
        hasUser: {
            type: Boolean,
            require: true
        },
        isClosed: {
            type: Boolean,
            require: true
        }
    },
    methods: {
        setDestination() {
            this.$store.dispatch('setDestinationId', this.event.id)
            this.$store.dispatch('setTransport', true)
        },
        async editEvent() {
            let event = this.event;
            await this.$store.dispatch('editEvent', event)
            this.event.sports.forEach(element => {
                this.$store.dispatch('changeSportsNew', element)
            })
        },
        addPhoto(url) {
            this.$store.dispatch('addPhotoTranslation', {url, event: this.event.id});
            this.$store.dispatch('addNotification', {message: 'Ваше фото успешно добавлено в трансляцию!'})
        },
        loadPhoto(input) {
            let files = input.target.files;
            files.length > 10
                ? this.$store.dispatch('addError', {
                    message: 'Максимум 10 фотографий',
                })
                : '';
            files.forEach(async (element, index) => {
                if (index < 10) {
                if (element.size / 1024 > 8000) {
                    this.$store.dispatch('addError', {message: 'Размер одной из фотографий превышает 8MB'});
                } else {

                    var reader = new FileReader();
                    reader.readAsDataURL(element)
                    reader.onload = async () => {
                    let url = reader.result;
                    let type = element.type.split('/')[1];
                    let size = element.size / 1024;
                    let path = "translations";
                    let name = this.$moment().format('ss-mm-HH_DD-MM-YYYY') + '_' + Math.round(Math.random() * 1000);
                    this.event.photos.unshift({
                        url: null,
                        key: null
                    });
                    let index = 0;
                    await this.$store.dispatch('uploadImage', {url, type: type || 'jpeg', name, size, path}).then(response => {
                        response.Location 
                            ? (this.event.photos[index].url = response.Location, this.event.photos[index].key = response.key) 
                            : (this.event.photos.splice(index, 1), this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'}));
                        this.addPhoto(response.Location)
                    }).catch(() => {
                        this.event.photos.splice(index, 1);
                        this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'})
                    });
                    };

                    reader.onerror = function() {
                    this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
                    };
                    
                    
                }
                }
            });
        },
    }
}
</script>